import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppContext } from 'src/components/app-context';
import ProductRow from 'src/components/product-row';
import { IconClose } from '@prisjakt/ui/icon/close';
import { IconButton, ButtonIcon } from '@prisjakt/ui/button/variants';
import { ProductImage } from 'src/components/product-image';
import { Column } from '@prisjakt/ui/list/variants';
import { BodyLargeText, BodySmallText } from '@prisjakt/ui/text/variants';

import { ProductAlertForm } from '../../../product-alert/components/product-alert-form';
import {
  createAlertRequest as createAlertRequestAction,
  removeAlertRequest as removeAlertRequestAction,
} from '../../../sidebar/actions/alert';
import ProductSearch from '../../../../components/product-search';

import {
  RoundedBluePanel,
  TextColumn,
  SelectedProductRow,
  AlertFormWrapper,
} from './styles';

class ProductAlertBox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      item: undefined,
    };
  }

  getPrivacyUrl() {
    const { market, renderMode } = this.context;
    return (
      market.privacySettings[renderMode] || market.privacySettings.responsive
    ).privacyUrl;
  }

  render() {
    const {
      sending,
      error,
      createAlertRequest,
      removeAlertRequest,
      campaignName,
    } = this.props;

    const { t, linkTo } = this.context;

    const { item } = this.state;

    if (item) {
      item.stockStatus = 'in_stock';
    }

    return (
      <RoundedBluePanel gap={1}>
        <TextColumn>
          <BodyLargeText color="light">
            {t('campaigns', 'inactive-campaign.alert-box-title')}
          </BodyLargeText>
          <BodySmallText color="light">
            {t('campaigns', 'inactive-campaign.alert-box-description', {
              campaignName,
            })}
          </BodySmallText>
        </TextColumn>
        <Column style={{ position: 'relative' }}>
          {item ? (
            <SelectedProductRow>
              <ProductRow
                key={item.id}
                id={item.id}
                link={linkTo('product', item)}
                name={item.name}
                image={<ProductImage name={item.name} src={item.image} />}
                rating={item.rating}
                price={item.price}
              />
              <IconButton
                onlyIcon
                onClick={() =>
                  this.setState({
                    item: undefined,
                  })
                }
              >
                <ButtonIcon>
                  <IconClose />
                </ButtonIcon>
              </IconButton>
            </SelectedProductRow>
          ) : (
            <ProductSearch
              onSelect={selectedItem => this.setState({ item: selectedItem })}
              showFloatingResult
              placeholder={t(
                'campaigns',
                'inactive-campaign.alert-box-search-placeholder'
              )}
            />
          )}
          {item && (
            <AlertFormWrapper>
              <ProductAlertForm
                productAlertFormData={{
                  product: {
                    ...item,
                    priceSummary: { regular: item.priceRaw },
                  },
                }}
                disabled={sending}
                error={error}
                showTypeSelect={false}
                onCreate={alert => createAlertRequest(alert, item.pathName)}
                onRemove={alertId =>
                  removeAlertRequest(alertId, item.id, item.pathName)
                }
                privacyPolicyUri={this.getPrivacyUrl()}
                showCancel={false}
                alertType="PRICE_DROPS"
                showRemoveButton={false}
              />
            </AlertFormWrapper>
          )}
        </Column>
      </RoundedBluePanel>
    );
  }
}

const { func, bool, string, oneOfType } = PropTypes;

ProductAlertBox.contextType = AppContext;

ProductAlertBox.propTypes = {
  createAlertRequest: func.isRequired,
  removeAlertRequest: func.isRequired,
  sending: bool.isRequired,
  success: bool.isRequired,
  error: oneOfType([bool, string]).isRequired,
  campaignName: string.isRequired,
};

const dispatchActions = {
  createAlertRequest: createAlertRequestAction,
  removeAlertRequest: removeAlertRequestAction,
};

export default connect(
  state => ({
    sending: state.areas.productAlert.sending,
    success: state.areas.productAlert.success,
    error: state.areas.productAlert.error,
  }),
  dispatchActions
)(ProductAlertBox);
